export default [
    {
        path: "/admin/cities-provinces",
        name: "city-provinceIndex",
        meta: true,
        component: () => import("@/pages/corporate/city-province/index.vue")
    },
];
